// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TechnicalTabsPage_tabs__2r-MT"};